module.exports = __webpack_public_path__ + "img/Galactapedia_Consolidated_Outland.3fa0f957.png";